export default __webpack_public_path__ + "static/2-0ab8bbbc53ed11d7e8cf381b3012ad2e.jpeg";